import { vasFilterToRequest } from 'app/main/apps/e-commerce/shared/vasFilterChoices';
import { salesPersonToRequest } from './personPickerOptions';
import { toMetricRangeParams } from './salesDashboardRange';

export const SALES_DASHBOARD_METRICS = [
  'DAILY_SALES',
  'WEEKLY_SALES',
  'MONTHLY_SALES',
  'QUARTERLY_SALES',
  'YEARLY_SALES',
  'CUMULATIVE_SALES',
  'MONTHLY_COMPARISON',
  'LOCATION_BASED_SALES',
  'GROSS_MARGIN_ANALYSIS',
  'GROSS_MARGIN_SUMMARY',
  'SALES_PERFORMANCE',
  'CUSTOMER_SALES',
  'LOW_CUSTOMER_ORDERS',
  'VAS_AMOUNTS',
];

export function buildSalesDashboardRequest({
  rangeType = 'YTD',
  person,
  vasFilter,
  limit = 9,
  now,
} = {}) {
  const payload = {
    metricsToInclude: SALES_DASHBOARD_METRICS,
    ...toMetricRangeParams(rangeType, now),
    limit,
  };

  const salesPerson = salesPersonToRequest(person);
  if (salesPerson) {
    payload.salesPerson = salesPerson;
  }

  const vas = vasFilterToRequest(vasFilter);
  if (vas) {
    payload.vasFilter = vas;
  }

  return payload;
}
